// extracted by mini-css-extract-plugin
export var checkbox = "_3p-0";
export var circle = "_3p-3";
export var horizontalContainer = "_3p-7";
export var sm = "_3p-5";
export var switch0 = "_3p-2";
export var switchDisabled = "_3p-8";
export var switchEnabled = "_3p-1";
export var textSwitchContainer = "_3p-9";
export var textSwitchOption = "_3p-a";
export var textSwitchOptionSelected = "_3p-b";
export var verticalContainer = "_3p-6";
export var xs = "_3p-4";